<template>
  <div class="pane-sidebar d-flex flex-column">
    <div class="pane-sidebar__header d-flex pa-4 column-gap-1 align-center flex-shrink-0">
      <app-icon-ai-assistant
        :width="28"
        :height="28"
        data-locator="pane-icon"
      />
      <span class="text--x-large font-weight-bold" data-locator="pane-title">
        {{ $t(`${TRANSLATION_KEY_PREFIX}.paneTitle`) }}
      </span>
    </div>

    <app-button
      class="w-full mx-3 my-2 app-button--surface-brand"
      type="primary"
      data-locator="create-conversation-button"
      @click="$emit('create-conversation')"
    >
      {{ $t(`${TRANSLATION_KEY_PREFIX}.createConversationButton`) }}
    </app-button>
    
    <!-- Contenu scrollable -->
    <div class="pane-sidebar__content flex-grow-1 overflow-y-auto pt-2">
      <AIAssistantMenuItem
        data-locator="conversations-menu-item"
        :is-opened="conversationsMenuOpened"
        :title="$t(`${TRANSLATION_KEY_PREFIX}.conversationsMenuTitle`)"
        @toggle-menu-item="$emit('toggle-conversations-menu')"
      >
        <AIAssistantConversationsList @select-conversation="$emit('select-conversation', $event)" />
      </AIAssistantMenuItem>
    </div>
    
    <!-- Footer fixe en bas -->
    <div class="pane-sidebar__footer flex-shrink-0 border-t px-4 py-4">
      <nav class="d-flex flex-column">
        <app-button
          class="justify-start"
          data-locator="ai-assistant-help-button"
          type="ghost"
          @click="isHelpCenterModalOpen = true"
        >
          <span class="icon-wrapper">
            <app-material-icon name="help" />
          </span>  
          <span>{{ $t(`${TRANSLATION_KEY_PREFIX}.helpButtonLabel`) }}</span>
        </app-button>
        <app-button
          class="justify-start"
          data-locator="ai-assistant-feedback-button"
          type="ghost"
        >
          <span class="icon-wrapper">
            <app-material-icon name="chat" :size="18" />
          </span>  
          <span>{{ $t(`${TRANSLATION_KEY_PREFIX}.feedbackButtonLabel`) }}</span>
        </app-button>
      </nav>
    </div>
    <AIAssistantHelpCenterModal  
      v-if="isHelpCenterModalOpen"
      @close="isHelpCenterModalOpen = false"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import { DARK_BLUE_DARKEST } from '@/common/utils/colors'

import AIAssistantConversationsList from './AIAssistantConversationsList.vue';
import AIAssistantHelpCenterModal from './AIAssistantHelpCenterModal.vue';
import AIAssistantMenuItem from './AIAssistantMenuItem.vue';
const TRANSLATION_KEY_PREFIX = 'common.ai-assistant.AIAssistantPaneSidebar'

export default defineComponent({
  name: 'AIAssistantPaneSidebar',
  components: {
    AIAssistantConversationsList,
    AIAssistantHelpCenterModal,
    AIAssistantMenuItem,
  },
  props: {
    conversationsMenuOpened: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      DARK_BLUE_DARKEST,
      TRANSLATION_KEY_PREFIX,
      isHelpCenterModalOpen: false,
    }
  },
})
</script>

<style scoped lang="scss">
.pane-sidebar {
  height: 100vh;
  max-height: 100vh;
}

.pane-sidebar__content {
  min-height: 0;
}

.icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
}
</style>